import { createPageNavigator } from "@-/dev.improve.haniverse.lib.navigator.page";
import { useCallback } from "react";

function useNavigator() {
  return useCallback(
    () => ({
      href: {
        pathname: "/(nav)/(app)/settings/daily-new-cards",
      },
      queries: [],
    }),
    [],
  );
}

export const useDailyNewCardsSettingsPageNavigator = createPageNavigator<void>({
  useNavigator,
});
